import { defineStore } from 'pinia'

export const useShopsStore = defineStore('shops', {
  state: () => ({
    shopsList: [
      {
        id: 20,
        company: 'Rijnja Amsterdam',
        name: 'Rijnja Amsterdam',
        street: 'Zekeringstraat',
        department: '',
        number: '46',
        addition: '',
        zipCode: '1014 BT',
        city: 'Amsterdam',
        phone: '020 611 43 04',
        email: 'amsterdam@rijnja.nl',
        lat: '52.39717',
        lng: '4.84866',
        image: 'amsterdam.png',
        url:
          'https://www.google.nl/maps/place/Koninklijke+Rijnja+Amsterdam/@52.3977659,4.8487148,15z/data=!4m5!3m4!1s0x47c5e2ed8e87e279:0xea7bd3cb63988d48!8m2!3d52.3971677!4d4.8486624'
      },
      {
        id: 51,
        company: 'Rijnja Den Haag',
        department: '',
        name: 'Rijnja Den Haag',
        street: 'Laan van Ypenburg',
        number: '84',
        addition: '',
        zipCode: '2497 GB',
        city: 'Den Haag',
        phone: '070 376 99 33',
        email: 'denhaag@rijnja.nl',
        lat: '52.043180',
        lng: '4.355320',
        image: 'den-haag.png',
        url:
          'https://www.google.nl/maps/place/Koninklijke+Rijnja+Den+Haag/@52.0424829,4.3563193,16z/data=!4m5!3m4!1s0x47c5b70e07529291:0x4382b5d347049bfa!8m2!3d52.0422717!4d4.3568504'
      },
      {
        id: 28,
        company: 'Rijnja Boxtel',
        department: '',
        name: 'Rijnja Boxtel',
        street: 'Ladonkseweg',
        number: '9',
        addition: '',
        zipCode: '5281 RN',
        city: 'Boxtel',
        phone: '040 250 12 10',
        email: 'boxtel@rijnja.nl',
        lat: '51.583610',
        lng: '5.314370',
        image: 'boxtel.png',
        url:
          'https://www.google.nl/maps/place/Koninklijke+Rijnja+Eindhoven/@51.5840087,5.3160411,16z/data=!4m5!3m4!1s0x47c6d988d00601ad:0xe7ea3de43934fa8e!8m2!3d51.5836421!4d5.3148556'
      },
      {
        id: 35,
        company: 'Rijnja Nieuwegein',
        department: '',
        name: 'Rijnja Nieuwegein',
        street: 'Ravenswade',
        number: '2B',
        addition: '',
        zipCode: '3439 LD',
        city: 'Nieuwegein',
        phone: '030 284 92 52',
        email: 'utrecht@rijnja.nl',
        lat: '52.050720',
        lng: '5.118180',
        image: 'nieuwegein.png',
        url:
          'https://www.google.nl/maps/place/Koninklijke+Rijnja+Utrecht/@52.0506058,5.1182563,15z/data=!4m9!1m2!2m1!1srijnja+nieuwegein!3m5!1s0x47c665edc213409b:0x4b656d08c6a3f11a!8m2!3d52.0506586!4d5.1185138!15sChFyaWpuamEgbmlldXdlZ2VpbiIDiAEBkgEYZGlnaXRhbF9wcmludGluZ19zZXJ2aWNl'
      },
      {
        id: 48,
        company: 'Rijnja Heerde',
        department: '',
        name: 'Rijnja Heerde',
        street: 'Europaweg',
        number: '9',
        addition: '',
        zipCode: '8181 BG',
        city: 'Heerde',
        phone: '038 425 03 25',
        email: 'heerde@rijnja.nl',
        lat: '',
        lng: '',
        image: 'heerde.png',
        url:
          'https://www.google.nl/maps/place/Europaweg+9,+8181+BG+Heerde/@52.3994929,6.0464839,14.64z/data=!4m5!3m4!1s0x47c7db5d714473db:0xc1d3b74a24750edb!8m2!3d52.397912!4d6.044996'
      },
      {
        id: 16,
        company: 'Rijnja Hoofdkantoor',
        department: '',
        name: 'Rijnja Hoofdkantoor',
        street: 'Ravenswade',
        number: '2B',
        addition: '',
        zipCode: '3439 LD',
        city: 'Nieuwegein',
        phone: '030 284 93 00',
        email: 'utrecht@rijnja.nl',
        lat: '52.06864',
        lng: '5.11066',
        hide: true,
        image: 'nieuwegein.png',
        url:
          'https://www.google.nl/maps/place/Koninklijke+Rijnja+Utrecht/@52.0506058,5.1182563,15z/data=!4m9!1m2!2m1!1srijnja+nieuwegein!3m5!1s0x47c665edc213409b:0x4b656d08c6a3f11a!8m2!3d52.0506586!4d5.1185138!15sChFyaWpuamEgbmlldXdlZ2VpbiIDiAEBkgEYZGlnaXRhbF9wcmludGluZ19zZXJ2aWNl'
      },
      {
        id: 49,
        company: 'Rijnja',
        department: '',
        name: 'Rijnja',
        street: 'Ravenswade',
        number: '2B',
        addition: '',
        zipCode: '3439 LD',
        city: 'Nieuwegein',
        phone: '030 284 93 00',
        email: 'helpdesk@rijnja.nl',
        lat: '52.06864',
        lng: '5.11066',
        hide: true,
        image: 'nieuwegein.png',
        url:
          'https://www.google.nl/maps/place/Koninklijke+Rijnja+Utrecht/@52.0506058,5.1182563,15z/data=!4m9!1m2!2m1!1srijnja+nieuwegein!3m5!1s0x47c665edc213409b:0x4b656d08c6a3f11a!8m2!3d52.0506586!4d5.1185138!15sChFyaWpuamEgbmlldXdlZ2VpbiIDiAEBkgEYZGlnaXRhbF9wcmludGluZ19zZXJ2aWNl'
      },
      {
        id: 47,
        company: 'Rijnja Rosmalen',
        department: '',
        name: 'Rijnja Rosmalen',
        street: '',
        number: '',
        addition: '',
        zipCode: '',
        city: 'Rosmalen',
        phone: '',
        email: 'helpdesk@rijnja.nl',
        lat: '52.06864',
        lng: '5.11066',
        hide: true
      },
      {
        id: 60,
        company: 'Rijnja Beegden',
        department: '',
        name: 'Rijnja Beegden',
        street: 'Beegderveld',
        number: '9',
        addition: '',
        zipCode: '6099 NC',
        city: 'Beegden',
        phone: '0475 22 20 10',
        email: 'beegden@rijnja.nl',
        hide: true,
        url:
          'https://www.google.nl/maps/place/Beegderveld+9,+6099+NC+Beegden/@51.1988941,5.9225447,1787m/data=!3m1!1e3!4m6!3m5!1s0x47c74ab4e6c8e95f:0xa18f647577e12a44!8m2!3d51.1987193!4d5.9260423!16s%2Fg%2F11ckqrnt5g?entry=ttu&g_ep=EgoyMDI2MDcyMi4wIKXMDSoASAFQAw%3D%3D'
      }
    ]
  })
})
